


{
  "familyId": "STU-COMBINEER",
  "questions": [
    {
      "id": "STU-COMBINEER-001",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je moet een werkstuk maken over het klimaat in de Sahara. Welke zoekterm levert de beste resultaten op?",
      "context": null,
      "options": ["klimaat Sahara woestijn", "werkstuk maken", "Sahara", "weer vandaag"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Zoekstrategieën", "content": "Combineer wat je zoekt (klimaat) + waar (Sahara) + type (woestijn). Hoe specifieker, hoe beter de resultaten.", "icon": "lightbulb" } }
      ],
      "conceptId": "search_strategy",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.zoek-op-opdracht", "label": "Zoekt op de opdracht i.p.v. het onderwerp", "optionIndex": 1 },
          { "id": "stu.zoekterm-te-breed", "label": "Gebruikt één te breed zoekwoord", "optionIndex": 2 },
          { "id": "stu.weer-vs-klimaat", "label": "Verwart 'weer' met 'klimaat'", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Combineer de belangrijkste woorden uit je vraag: 'klimaat' (wat) + 'Sahara' (waar) + 'woestijn' (type). Hoe specifieker, hoe gerichter de resultaten.",
        "solutionSteps": [
          "Wat zoek je? → klimaat",
          "Waar? → Sahara",
          "Type gebied? → woestijn",
          "Combineer: 'klimaat Sahara woestijn'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Klimaat Sahara woestijn' levert specifieke resultaten op.",
          "1": "Zoek op je onderwerp, niet op wat je moet doen.",
          "2": "Alleen 'Sahara' is te breed — je krijgt resultaten over alles in de Sahara.",
          "3": "'Weer' = nu, 'klimaat' = gemiddelde over jaren. Niet hetzelfde."
        }
      }
    },
    {
      "id": "STU-COMBINEER-002",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je hebt een tabel met temperatuurgegevens én een kaart van Europa. Welke conclusie kun je trekken door deze twee bronnen te combineren?",
      "context": null,
      "options": [
        "Landen in het zuiden van Europa zijn gemiddeld warmer dan landen in het noorden.",
        "Europa heeft meer landen dan andere continenten.",
        "De temperatuur in Europa is overal hetzelfde.",
        "Kaarten zijn altijd betrouwbaarder dan tabellen."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bronnen combineren", "content": "Tabel = de cijfers. Kaart = de ligging. Samen zie je: zuidelijke landen zijn warmer.", "icon": "lightbulb" } }
      ],
      "conceptId": "combine_sources_geography",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.conclusie-buiten-bron", "label": "Trekt conclusie die niet uit bronnen volgt", "optionIndex": 1 },
          { "id": "stu.bron-negeren", "label": "Negeert de gegeven cijfers", "optionIndex": 2 },
          { "id": "stu.bronnen-vergelijken-ipv-combineren", "label": "Vergelijkt bronnen i.p.v. ze samen te gebruiken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Tabel geeft temperaturen, kaart geeft ligging. Samen zie je: zuidelijke landen (dichter bij evenaar) zijn warmer.",
        "solutionSteps": [
          "Bron 1: tabel met temperaturen",
          "Bron 2: kaart met ligging",
          "Koppel: temperatuur ↔ ligging",
          "Conclusie: zuid = warmer"
        ],
        "distractorExplanations": {
          "0": "Goed! Door beide bronnen combineren zie je het zuid-noord-verschil.",
          "1": "Aantallen landen op andere continenten staan niet in deze bronnen.",
          "2": "De tabel laat juist verschillen zien — niet alles is gelijk.",
          "3": "Het gaat om combineren, niet kiezen welke bron beter is."
        }
      }
    },
    {
      "id": "STU-COMBINEER-003",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "true_false_series",
      "question": "Beoordeel elke uitspraak over informatiebronnen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Een tabel geeft cijfers, een tekst geeft uitleg en context.", "isTrue": true },
          { "text": "Cijfers in een grafiek zijn altijd betrouwbaarder dan tekst.", "isTrue": false },
          { "text": "Foto's en grafieken kunnen elkaar versterken in een presentatie.", "isTrue": true },
          { "text": "Als je twee bronnen combineert, moet je altijd één van beide kiezen.", "isTrue": false },
          { "text": "Bij elk onderwerp is het slim om verschillende soorten bronnen te gebruiken.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bronnen vullen elkaar aan", "content": "Cijfers ≠ altijd betrouwbaarder. Tekst en grafiek zijn niet concurrerend, maar aanvullend. Combineer = beide gebruiken, niet kiezen.", "icon": "lightbulb" } }
      ],
      "conceptId": "sources_tf_basis",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "1) Waar — tabel = cijfers, tekst = uitleg. 2) Onwaar — cijfers kunnen ook misleidend zijn (bv. uit beperkte steekproef). 3) Waar — beeld + cijfer = sterker. 4) Onwaar — combineren = beide gebruiken. 5) Waar — variatie van bronnen geeft completer beeld.",
        "solutionSteps": [
          "Tabel = cijfers, tekst = uitleg → WAAR",
          "Cijfers altijd betrouwbaarder → ONWAAR",
          "Foto + grafiek versterken elkaar → WAAR",
          "Combineren = kiezen → ONWAAR",
          "Variatie = completer beeld → WAAR"
        ]
      }
    },
    {
      "id": "STU-COMBINEER-004",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Je leest een artikel over gezond eten. Daarin staat een tabel met voedingsrichtlijnen én een cirkeldiagram over wat jongeren eten. Welke vraag kun je beantwoorden door beide bronnen te combineren?",
      "context": null,
      "options": [
        "Eten jongeren genoeg groente volgens de richtlijnen?",
        "Hoeveel calorieën zit er in een appel?",
        "Wat is het favoriete eten van volwassenen?",
        "Hoe maak je een gezonde maaltijd klaar?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Combineren = vergelijken", "content": "Tabel = wat zou moeten (richtlijn). Diagram = wat is (gedrag). Samen kun je vergelijken: hoort dat bij elkaar?", "icon": "lightbulb" } }
      ],
      "conceptId": "combine_for_conclusion",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.een-bron-volstaat", "label": "Heeft maar één bron nodig (calorieën uit tabel)", "optionIndex": 1 },
          { "id": "stu.bron-doelgroep-verwart", "label": "Verwart doelgroep van bronnen (volwassenen i.p.v. jongeren)", "optionIndex": 2 },
          { "id": "stu.conclusie-buiten-bron", "label": "Trekt conclusie buiten bronnen (recepten)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vergelijk de richtlijn (tabel) met de werkelijkheid (diagram). Alleen als beide bronnen samen worden gebruikt kun je vaststellen of jongeren gezond genoeg eten.",
        "solutionSteps": [
          "Bron 1: voedingsrichtlijnen",
          "Bron 2: eetgewoonten van jongeren",
          "Combineer: vergelijk norm en werkelijkheid",
          "Conclusie: hoort wat jongeren eten bij de richtlijn?"
        ],
        "distractorExplanations": {
          "0": "Goed! Vergelijking norm ↔ werkelijkheid = combineren.",
          "1": "Calorieën in een appel haal je uit één bron — geen combineren nodig.",
          "2": "Het diagram gaat over jongeren, niet volwassenen.",
          "3": "Geen van beide bronnen bevat recepten."
        }
      }
    },
    {
      "id": "STU-COMBINEER-005",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "ordering",
      "question": "Een leerling maakt een presentatie over watervervuiling. Hij heeft: (1) een foto van een vervuilde rivier, (2) een grafiek met waterkwaliteit door de jaren heen, (3) een tekst van een milieuorganisatie met oplossingen. Zet deze bronnen op volgorde voor een sterke presentatie (eerst getoond → laatst getoond).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["foto van vervuilde rivier", "grafiek met waterkwaliteit", "tekst met oplossingen"],
        "correctOrder": [0, 1, 2]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Opbouw van een sterke presentatie", "content": "Begin met aandacht trekken (foto), dan onderbouwing met feiten (grafiek), eindig met conclusie en oplossingen (tekst).", "icon": "lightbulb" } }
      ],
      "conceptId": "presentation_order",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Sterke presentatie: foto (haakt de aandacht) → grafiek (onderbouwt met feiten) → tekst (geeft conclusie en oplossingen).",
        "solutionSteps": [
          "Stap 1: foto trekt aandacht (emotie)",
          "Stap 2: grafiek onderbouwt met feiten",
          "Stap 3: tekst sluit af met oplossingen"
        ]
      }
    },
    {
      "id": "STU-COMBINEER-006",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "categorize",
      "question": "Sorteer elke bron naar wat hij vooral biedt: harde feiten/cijfers, beeld/emotie, of uitleg/context.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Feiten/cijfers", "Beeld/emotie", "Uitleg/context"],
        "items": [
          { "text": "een staafdiagram", "correctCategory": 0 },
          { "text": "een foto van een gevolg", "correctCategory": 1 },
          { "text": "een tekst van een expert", "correctCategory": 2 },
          { "text": "een tabel met metingen", "correctCategory": 0 },
          { "text": "een interview", "correctCategory": 2 },
          { "text": "een tekening of illustratie", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Drie soorten bijdragen", "content": "Cijfers/feiten = grafieken, tabellen. Beeld/emotie = foto's, tekeningen. Uitleg/context = teksten, interviews.", "icon": "lightbulb" } }
      ],
      "conceptId": "sources_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Cijfers: staafdiagram, tabel. Beeld: foto, tekening. Uitleg: tekst van expert, interview. Een goede presentatie gebruikt alle drie.",
        "solutionSteps": [
          "Staafdiagram → cijfers",
          "Foto → beeld/emotie",
          "Tekst expert → uitleg",
          "Tabel → cijfers",
          "Interview → uitleg",
          "Tekening → beeld/emotie"
        ]
      }
    },
    {
      "id": "STU-COMBINEER-007",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "multiple_choice",
      "question": "Een leerling onderzoekt of er een verband is tussen schermtijd en concentratie op school. Welke combinatie van bronnen geeft de meest betrouwbare conclusie?",
      "context": null,
      "options": [
        "Een wetenschappelijk artikel + een eigen enquête onder klasgenoten + cijfers van de overheid.",
        "Eén filmpje van een influencer over schermtijd.",
        "Wat zijn vrienden zeggen over concentratie.",
        "Eén commercial van een telefoonmaker."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Betrouwbaarheid van bronnen", "content": "Combineer onafhankelijke bronnen: wetenschap (onderzoek), eigen data (enquête) en officiële cijfers. Eén bron of een commerciële bron is niet betrouwbaar genoeg.", "icon": "lightbulb" } }
      ],
      "conceptId": "combine_reliability",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.een-bron-volstaat", "label": "Eén bron is genoeg", "optionIndex": 1 },
          { "id": "stu.anekdote-als-bewijs", "label": "Verhalen van vrienden tellen als bewijs", "optionIndex": 2 },
          { "id": "stu.commercieel-als-onafhankelijk", "label": "Commerciële bron als objectief", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De sterkste onderbouwing combineert verschillende soorten bronnen (wetenschap + eigen data + officiële cijfers). Eén filmpje, alleen meningen van vrienden of een commercial zijn niet betrouwbaar genoeg.",
        "solutionSteps": [
          "Wetenschap = onderzoek (onafhankelijk)",
          "Enquête = eigen data",
          "Overheid = officiële cijfers",
          "Combinatie = sterk bewijs"
        ],
        "distractorExplanations": {
          "0": "Goed! Drie verschillende, onafhankelijke bronnen geven sterke onderbouwing.",
          "1": "Eén filmpje is geen bewijs — controleer altijd met meerdere bronnen.",
          "2": "Meningen van vrienden zijn anekdotes, geen onderzoek.",
          "3": "Een commercial wil iets verkopen — niet objectief."
        }
      }
    },
    {
      "id": "STU-COMBINEER-008",
      "familyId": "STU-COMBINEER",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "presenteren",
      "subSkill": "info_combineren",
      "questionType": "matching",
      "question": "Koppel elke onderzoeksvraag aan de bronnen die je hierbij het best combineert.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Hoeveel regen viel er per maand vorig jaar?", "right": "tabel KNMI + lijngrafiek per maand" },
          { "left": "Waarom protesteren mensen tegen een nieuwe weg?", "right": "krantenartikel + interview met bewoners" },
          { "left": "Hoe ziet een Romeinse helm eruit?", "right": "foto in museum + uitleg in geschiedenisboek" },
          { "left": "Welke landen winnen vaak medailles op de Olympische Spelen?", "right": "tabel met medailles + wereldkaart" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Match bron aan vraag", "content": "Cijfers? → tabel/grafiek. Mening of reden? → interview/artikel. Hoe-iets-eruitziet? → foto + uitleg. Verband tussen plaats en data? → tabel + kaart.", "icon": "lightbulb" } }
      ],
      "conceptId": "combine_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Cijfers per maand → tabel + grafiek. Meningen → krant + interview. Uiterlijk van een voorwerp → foto + uitleg. Geografische verbanden → tabel + kaart.",
        "solutionSteps": [
          "Hoeveelheid regen → cijfers (tabel + grafiek)",
          "Waarom protest → meningen (artikel + interview)",
          "Romeinse helm → uiterlijk (foto + tekst)",
          "Olympische medailles per land → cijfers + plaats (tabel + kaart)"
        ]
      }
    }
  ]
}


